import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';


export class XEventService {
    public readonly events: Observable<XEvent> = new Subject();

    constructor() {}

    triggerEvent(event: any): void {
        event = event as XEvent;
        if ((event.mode !== null) && (event.mode !== undefined)) {
        } else if (event.name.indexOf('x-') === 0) {
            event.mode = XEventMode.CrossWindow;
        } else if (event.name.indexOf('a-') === 0) {
            event.mode = XEventMode.All;
        } else {
            event.mode = XEventMode.CurrentWindow;
        }
        if (event.mode & XEventMode.CurrentWindow) {
            (this.events as Subject<XEvent>).next(event);
        }
    }
}

export enum XEventMode {
    CurrentWindow = 1 << 1,
    CrossWindow = 1 << 2,
    All = CurrentWindow | CrossWindow
}

export interface XEvent {
    name: string;
    data: any;
    sender: any;
    mode: XEventMode;
}
